import { compose } from "@reduxjs/toolkit";
import { connect } from "react-redux";
import TemplateList from "./template-list";
import { getValue } from "store/languages";
import { setSelectedReportTemplate, setIsReadOnly, copyTemplate } from "store/report-constructor";
import { modalShowToggle } from "store/modal";

let mapStateToProps = (state) => {
    return {
        reportTemplates: state.ReportConstructor.reportTemplates,
        isReportsUpdated: state.ReportConstructor.isReportsUpdated,
        reportComponents: state.ReportConstructor.reportComponents,
        controlButtons: state.ReportConstructor.controlButtons,
        isReadOnly: state.ReportConstructor.isReadOnly,
        selectedLanguage: state.languages.selectedLanguage,
        selectedReportTemplate: state.ReportConstructor.selectedReportTemplate,
        currentPage: state.paginator.currentPage,
        showedItemsCount: state.paginator.showedItemsCount,
    }
}

const ReportListContainer = (TemplateList);

export default compose(
    connect(
        mapStateToProps, {
            getValue,
            setSelectedReportTemplate,
            setIsReadOnly,
            copyTemplate,
            modalShowToggle
        }
    )
) (ReportListContainer)
